import { useMemo } from 'react';
import { useGetFilter } from './useSearchParamsObj';
import { DynamicObjectType } from 'types/commons';

const useGetSearchKey = (data: DynamicObjectType[]) => {
  const { searchParams } = useGetFilter();

  const searchKeys = useMemo(() => {
    return (
      data?.find((item) => item.value === searchParams.get('fieldSearch'))
        ?.searchKeys || []
    );
  }, [searchParams.get('fieldSearch')]);

  return { searchKeys };
};

export default useGetSearchKey;
